export const labelSheetsFor = (layout, labels, startAt = 1) => {
    const perSheet = Math.max(1, layout.columns * layout.rows);
    const skipped = Math.min(Math.max(Math.trunc(startAt), 1), perSheet) - 1;
    const count = Math.max(0, Math.trunc(labels));
    if (count === 0) {
        return { perSheet, sheets: 0, emptyOnLast: 0, isRoll: perSheet === 1 };
    }
    const used = skipped + count;
    const sheets = Math.ceil(used / perSheet);
    return {
        perSheet,
        sheets,
        emptyOnLast: sheets * perSheet - used,
        isRoll: perSheet === 1,
    };
};
//# sourceMappingURL=sheets.js.map